import { combineSlices } from '@reduxjs/toolkit';
import { promocodeSlice } from './promocode';
import { summarySlice } from './summary';
import { productsSlice } from './products';
import { recommendationProductsSlice } from './recommendationProducts';

export const rootReducer = combineSlices(
  promocodeSlice,
  summarySlice,
  productsSlice,
  recommendationProductsSlice
);
